import { render, staticRenderFns } from "./detail-info.vue?vue&type=template&id=7fe7b764&scoped=true&"
import script from "./detail-info.vue?vue&type=script&lang=ts&"
export * from "./detail-info.vue?vue&type=script&lang=ts&"
import style0 from "./detail-info.vue?vue&type=style&index=0&id=7fe7b764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe7b764",
  null
  
)

export default component.exports